import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import { AbsProduct } from '@/creditflowresearch/domain/Product';
import ABSContextProvider from '@/creditflowresearch/application/Deal/contexts/IssueTile/AbsContext';
import CorporateContextProvider from '@/creditflowresearch/application/Deal/contexts/IssueTile/CorporateContext';
import { IssueTile } from '@/creditflowresearch/ui/components/deals/DealTiles/IssueTile/IssueTile';
import { withTileContext } from '@/creditflowresearch/ui/components/deals/DealTiles/withTileContexts';
import DealRepository from '@/creditflowresearch/infrastructure/repository/DealRepository';
import { getContainer } from '@framework/di/getContainer';
import { prepareDealDataForProductType } from '@/creditflowresearch/application/Deal/helpers/productGrouping';

export default withTileContext(({ title }: { title?: string }) => {
  const { deals } = useParentPageContext();
  const container = getContainer();
  const dealRepository = container.get<DealRepository>(DealRepository);

  return (
    <ABSContextProvider
      deals={ prepareDealDataForProductType(deals, AbsProduct.ABBREVIATION.toLowerCase()) }
      fetch={ dealRepository.getDeals }
      additionalFilters={ {} }
    >
      <CorporateContextProvider
        deals={ prepareDealDataForProductType(deals, 'corporate') }
        fetch={ dealRepository.getCorporateDeals }
        additionalFilters={ {} }
      >
        <IssueTile showTileTabs title={ title } defaultExpandedRowIndexes={ [0] } />
      </CorporateContextProvider>
    </ABSContextProvider>
  );
});
